import { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { Button } from './Button';

interface Props {
  open: boolean;
  title: string;
  copy: string;
  confirmLabel: string;
  cancelLabel: string;
  busy?: boolean;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ open, title, copy, confirmLabel, cancelLabel, busy, danger = true, onConfirm, onCancel }: Props) {
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const keydown = (event: KeyboardEvent) => { if (event.key === 'Escape' && !busy) onCancel(); };
    window.addEventListener('keydown', keydown);
    return () => { document.body.style.overflow = previous; window.removeEventListener('keydown', keydown); };
  }, [busy, onCancel, open]);
  if (!open) return null;
  return <div className="confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
    <button type="button" className="confirm-dialog__scrim" aria-label={cancelLabel} onClick={busy ? undefined : onCancel} />
    <section className="confirm-dialog__card">
      <button type="button" className="icon-button confirm-dialog__close" aria-label={cancelLabel} onClick={onCancel} disabled={busy}><X /></button>
      <span className="confirm-dialog__icon"><AlertTriangle /></span>
      <h2 id="confirm-dialog-title">{title}</h2>
      <p>{copy}</p>
      <div className="confirm-dialog__actions"><Button type="button" variant="secondary" onClick={onCancel} disabled={busy}>{cancelLabel}</Button><Button type="button" variant={danger ? 'danger' : 'primary'} busy={busy} onClick={onConfirm}>{confirmLabel}</Button></div>
    </section>
  </div>;
}
